import { __rest } from "tslib";
import React from 'react';
import { Avatar as MuiAvatar, makeStyles } from '@material-ui/core';
import { reactStyling } from '@getgo/chameleon-core';
import clsx from 'clsx';
const useStyles = makeStyles((theme) => {
    const { avatar, avatarIcon, avatarXsmall, avatarXsmallIcon, avatarSmall, avatarSmallIcon, avatarLarge, avatarLargeIcon, avatarXlarge, avatarXlargeIcon, avatarXxlarge, avatarXxlargeIcon, avatarXxxlarge, avatarXxxlargeIcon, } = reactStyling(theme.tokens);
    return {
        avatar: Object.assign(Object.assign({}, avatar), { border: '1px solid transparent', boxSizing: 'content-box', outline: 0 }),
        xsmall: Object.assign(Object.assign({}, avatarXsmall), { '& svg': Object.assign({}, avatarXsmallIcon) }),
        small: Object.assign(Object.assign({}, avatarSmall), { '& svg': Object.assign({}, avatarSmallIcon) }),
        medium: {
            '& svg': Object.assign({}, avatarIcon),
        },
        large: Object.assign(Object.assign({}, avatarLarge), { '& svg': Object.assign({}, avatarLargeIcon) }),
        xlarge: Object.assign(Object.assign({}, avatarXlarge), { '& svg': Object.assign({}, avatarXlargeIcon) }),
        xxlarge: Object.assign(Object.assign({}, avatarXxlarge), { '& svg': Object.assign({}, avatarXxlargeIcon) }),
        xxxlarge: Object.assign(Object.assign({}, avatarXxxlarge), { '& svg': Object.assign({}, avatarXxxlargeIcon) }),
        avatarContainer: {
            position: 'relative',
        },
        presence: {
            bottom: -5,
            position: 'absolute',
            right: -2,
        },
        presenceSmall: {
            bottom: -4,
        },
        presenceMedium: {
            bottom: -2,
            right: -1,
        },
        presenceLarge: {
            bottom: 0,
            right: 0,
        },
        presenceXlarge: {
            bottom: 0,
            right: 4,
        },
        presenceXXlarge: {
            bottom: 6,
            right: 3,
        },
    };
});
export const Avatar = (_a) => {
    var { children, size = 'medium', presence, className } = _a, otherProps = __rest(_a, ["children", "size", "presence", "className"]);
    const classes = useStyles();
    const avatar = (React.createElement(MuiAvatar, Object.assign({ className: clsx(classes.avatar, classes[size], className), tabIndex: 0 }, otherProps), children));
    return presence ? (React.createElement("span", { className: clsx(classes.avatarContainer) },
        avatar,
        presence && (React.createElement("span", { className: clsx(classes.presence, size === 'small' ? classes.presenceSmall : '', size === 'medium' ? classes.presenceMedium : '', size === 'large' ? classes.presenceLarge : '', size === 'xlarge' ? classes.presenceXlarge : '', size === 'xxlarge' ? classes.presenceXXlarge : '') }, presence)))) : (avatar);
};
